import { render, staticRenderFns } from "./JudgementListContent.vue?vue&type=template&id=09b106cb&"
import script from "./JudgementListContent.vue?vue&type=script&lang=ts&"
export * from "./JudgementListContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports